<template>
  <b-form  @submit.prevent>
    <div class="white-section box-info mb-2 pt-3">
      <section class="box-has-title mb-3">
        <b-row>
          <b-col md="3" sm="6" xl="2">
            <b-form-group
              :label="$t('user.gender')"
              label-for="user-gender"
            >
              <b-form-radio-group
                id="user-gender"
                ref="gender"
                v-model="gender"
                :options="genders"
              ></b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col md="3" sm="6" xl="2">
            <b-form-group
              :label="$t('user.name')"
              label-for="user-first-name"
            >
              <b-form-input
                id="user-first-name"
                v-model="firstName"
                @keypress="validateInput"
              />
            </b-form-group>
          </b-col>
          <b-col md="3" sm="6" xl="2">
            <b-form-group
              :label="$t('user.lastName')"
              label-for="user-lastname"
            >
              <b-form-input
                id="user-lastname"
                v-model="lastName"
                aria-describedby="user-lastname-feedback"
                @keypress="validateInput"

              />
            </b-form-group>
          </b-col>
          <b-col md="3" sm="6" xl="2" v-if="showCode">
            <b-form-group
              :label="$t('user.nationalCode')"
              label-for="user-nationalCode"
            >
              <b-form-input
                id="user-nationalCode"
                v-model="nationalCode"
                @keypress="preventNationalType($event)"
              />
            </b-form-group>
          </b-col>
          <b-col md="3" sm="6" xl="2">
            <b-form-group
              :label="$t('user.nationality')"
              label-for="user-nationality"
            >
              <my-v-select
                :key="countryId"
                id="user-nationality"
                v-model="countryId"
                :multiple="false"
                :options="countries && countries.length ? countries : []"
                :translate="false"
                :concat-label="['title.fa']"
                :searchable="true"
                :filterable="true"
                @input="countrySelected"
              />
            </b-form-group>
          </b-col>
          <!-- Item Mobile -->
          <!-- <b-col md="3" xl="2">
            <b-form-group
              :label="$t('user.mobile')"
              label-for="user-mobile"
            >
              <b-form-input
                id="user-mobile"
                v-model="mobile"
                aria-describedby="user-mobile-help"
                type="text"
                @keypress="preventMobileType($event)"
                dir="ltr"
                autocomplete="off"
              />
              <b-form-text id="user-mobile-help"
                >{{ $t("hint.mobile") }}
              </b-form-text>
            </b-form-group>
          </b-col> -->
          <b-col lg="3" md="4" sm="6" xl="2">
            <b-form-group
              :invalid-feedback="
                invalidFeedbackMobile
                  ? $t(`validation.${invalidFeedbackMobile}`, {
                      field: $t('user.mobile'),
                      current: $t('user.anotherMobile'),
                    })
                  : ''
              "
              :label="$t('user.mobile')"
              :state="
                $v.mobile.$dirty
                  ? !$v.mobile.$invalid === false
                    ? false
                    : null
                  : null
              "
              :class="{
                'required-group': !$v.mobile.required,
              }"
              label-for="user-mobile"
            >
              <!-- :state="$v.mobiles.$dirty ? !$v.mobile.$invalid : null" -->
              <!-- :state="$v.mobile.$dirty ? !$v.mobile.$invalid : null" -->
              <b-form-input
                id="user-mobile"
                v-model="mobile"
                :state="
                  $v.mobile.$dirty
                    ? !$v.mobile.$invalid === false
                      ? false
                      : null
                    : null
                "
                aria-describedby="user-mobile-help"
                type="number"
                @keypress="preventMobileType($event)"
                dir="ltr"
              />
              <b-form-text v-if="hint" id="user-mobile-help"
                >{{ $t("hint.mobile") }}
              </b-form-text>
            </b-form-group>
          </b-col>
          <b-col md="3" xl="2">
            <b-form-group
              :label="$t('user.dialCode')"
              label-for="user-mobile-dialcode"
            >
              <v-select
              :items="countriesWithCode"
              v-model="mobileCountryId"
              :key="mobileCountryId"
              id="user-mobile-dialcode"
              item-text="titleAndCode"
              item-value="_id"
              @input="countrySelected"
              attach
              class="selectCountri"
              :searchable="true"
              :filterable="true"
            >
            <template v-slot:selection="{ item }">
              <img :src="item.wikipedia_image" style="width:20px; height:20px; margin-right:10px ; margin-left:10px">
              {{ item.phoneCode }}
            </template>
              <template v-slot:item="{ item }">
                <img :src="item.wikipedia_image" style="width:20px; height:20px; margin-right:10px ; margin-left:10px">
                {{ item.phoneCode }}
              </template>
            </v-select>
            </b-form-group>
          </b-col>
          <b-col md="3" sm="6" xl="2">
            <b-form-group
              :label="$t('user.fathersName')"
              label-for="user-fathersName"
            >
              <div class="form-label-group">
                <b-form-input
                  id="user-fathersName"
                  v-model="fatherName"
                  @keypress="validateInput"
                />
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <div class="d-flex justify-content-start">
            <b-button
            size=""
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="info"
            class="ml-auto"
            @click="editUser"
        >
            {{ $t("general.submit") }}
        </b-button>
        </div>
      </section>
      </div>
  </b-form>
</template>

<script>
import MyCleaveDate from "@/components/wrapper/datePicker/MyCleaveDate.vue";

import dateFormat from "@/mixins/dateFormat";
import mobileRepeaterBasic from "@/components/user/mobile-repeater/MobileRepeaterBasic";
import mobileValidation from "@/mixins/validations/mobile";
import postalCodeValidation from "@/mixins/validations/postalCode";
import addressRepeaterBasic from "@/components/user/address-repeater/AddressRepeaterBasic";
import userSpouseRepeater from "@/components/user/user-spouse-repeater/UserSpouseRepeater.vue";
import phoneRepeaterBasic from "@/components/user/phone-repeater/PhoneRepeaterBasic";
import filterRoles from "@/mixins/filterRoles";

import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BFormSelect,
  BFormInvalidFeedback,
  BFormSelectOption,
  BFormRadioGroup,
  BFormText,
} from "bootstrap-vue";
import {
  requiredIf,
  maxLength,
} from "vuelidate/lib/validators";
import Ripple from "vue-ripple-directive";
import { mapGetters } from "vuex";
import moment from "jalali-moment";
import MyAbDatePicker from "@/components/wrapper/datePicker/MyAbDatePicker";
import ForeignerInfo from "@/components/user/Foreigner/ForeignerInfo";
import MyVSelect from "@/components/wrapper/select/MyVSelect";
import Cleave from "vue-cleave-component";
import nationalCodeValidation from "@/mixins/validations/nationalCode";
export default {
  data: () => ({
    gender:"",
    firstName:"",
    lastName:"",
    fatherName:"",
    countryId:"",
    mobileCountryId:"",
    mobile:"",
    nationalCode:"",
    showCode:false,
    nationalCodeUser:""
  }),
  mounted() {

  },
  components: {
    MyVSelect,
    ForeignerInfo,
    MyAbDatePicker,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BFormSelect,
    BFormInvalidFeedback,
    mobileRepeaterBasic,
    addressRepeaterBasic,
    phoneRepeaterBasic,
    BFormSelectOption,
    BFormRadioGroup,
    BFormText,
    userSpouseRepeater,
    MyCleaveDate,
    Cleave,
  },
  mixins:{
    nationalCodeValidation
  },
  directives: {
    Ripple,
  },
  created() {
    this.$store.commit("user/RESET_MODULE");

    let params = this.$route.params;
    this.$store.commit("SET_IS_LOADING", true);
    this.$store.dispatch("user/findUser", params.id).then((user) => {
      this.nationalCodeUser= user.nationalCode
        this.gender=user.gender,
        this.firstName=user.firstName,
        this.lastName=user.lastName,
        this.fatherName=user.fatherName,
        this.countryId=user.countryId,
        this.mobileCountryId=user.mobileCountryId,
        this.mobile=user.mobile,
        this.nationalCode= this.nationalCodeUser

      this.pushBreadcrumb({
        text: "editPatient",
        to: { name: "editPatient" },
        translate: true,
      });
      this.pushBreadcrumb({
        text: user.firstName + " " + user.lastName,
        translate: false,
      });
      this.setCurrentBreadcrumb([
        {
          text: "editPatient",
          to: { name: "editPatient" },
          translate: true,
        },
        { text: user.firstName + " " + user.lastName, translate: false },
      ]);
      this.$store.commit("user/SET_USER_TO_EDIT", user);
      this.$store.dispatch("location/countries").then((countries) => {
        this.$store.commit("SET_IS_LOADING", false);
        let iran = countries.find((c) => c["alpha_2"] === "IR")._id;
        this.nationalCode= this.nationalCodeUser
        if(this.countryId === iran){
          this.showCode=true
          this.countrySelected();
        }
      });

    });
  },
    watch:{
      countryId(){
        let iran = this.countries.find((c) => c["alpha_2"] === "IR")._id;
        if(this.countryId === iran){
          this.showCode=true
          this.nationalCode= this.nationalCodeUser
        }else{
          this.showCode=false
          this.nationalCode=null
        }
      }
    },
  mixins: [
    nationalCodeValidation,
    dateFormat,
    mobileValidation,
    postalCodeValidation,
    filterRoles,
  ],
  validations() {
  return{
    nationalCode: {
        required: requiredIf(() => {
          return this.showCode
            ? (this.nationalCodeValidation = (value) =>
                this.nationalCodeValidation(value))
            : false
        }),
        maxLength: maxLength(10),
      },
      mobile: {
        maxLength: maxLength(11),
        mobileValidation: (value) =>  this.countries.find((c) => c["alpha_2"] === "IR")._id || this.countries.find((c) => c["alpha_2"] === "AF")._id ? this.mobileValidation(value) : true ,
        required: requiredIf(()=>{
          return  this.countries.find((c) => c["alpha_2"] === "IR")._id || this.countries.find((c) => c["alpha_2"] === "AF")._id
        })
      },
}
  },
  computed: {
    ...mapGetters({
      genders: "user/genders",
      valid: "validation/valid",
      countries: "location/countries",
      cities: "location/cities",
      birthCities: "location/cities",
      mobiles: "user/mobiles",
    }),
    invalidFeedbackMobile: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.mobile.$dirty) return error;
        if (!this.$v.mobile.required) {
          error = "required";
          return error;
        }
        if (!this.$v.mobile.mobileValidation) {
          error = "invalid";
          return error;
        }
        if (!this.$v.mobile.notTheSame) error = "notSameAs";
        return error;
      },
    },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.name;
    });
  },
  countriesWithCode() {
      return this.countries.map(country => ({
        ...country,
        titleAndCode: `${country.phoneCode} `
      }));
    }
},
  methods: {
    preventNationalType(value) {
      if (this.nationalCode.length >= 10) {
        value.preventDefault();
        return;
      }
    },
    preventMobileType(value) {
      const charCode = value.charCode;
      if (this.mobile.length >= 11) {
        value.preventDefault();
        return;
      }
      if( charCode < 48 || charCode > 57){
        value.preventDefault();
        return;
      }
    },
    countrySelected() {
      let selected = this.countries.find((c) => {
        return c._id == this.countryId;
      });
      if (selected["alpha_2"] === "AF") {
        this.mobileCountryId = this.countries.find((c) => {
          return c["alpha_2"] === "IR";
        })._id;
      } else {
        this.mobileCountryId = this.countryId;
      }
      if (selected["alpha_2"] !== "AF" && selected["alpha_2"] !== "IR") {
        this.hint = false;
      } else {
        this.hint = true;
      }
      if (selected["alpha_2"] !== "IR") {
        this.isForeigner = true;
        this.ShowNationalCode = true;
      } else {
        this.isForeigner = false;
        this.ShowNationalCode = false;
      }
      if (selected["alpha_2"] == "IR") {
        this.isForeigner = false;
        this.birthCity = null;
      } else if (
        this.role.find(
          (r) =>
            r === this.filterRoles("patient") ||
            r === this.filterRoles("nurse") ||
            r === this.filterRoles("midwife")
        )
      ) {
        this.isForeigner = true;
      }
    },
    findUser() {
      let params = this.$route.params;
      this.$store.dispatch("user/findUser", params.id).then((user) => {
        this.$store.commit("user/SET_USER_TO_EDIT", user);
      });
    },
    validateInput(event) {
      const charCode = event.charCode;
      if (charCode >= 48 && charCode <= 57) {
        event.preventDefault();
      }
    },
    editUser() {
      var regex = new RegExp(
        "09(0[0-9]|1[0-9]|3[0-9]|2[0-9]|9[0-9])-?[0-9]{3}-?[0-9]{4}"
      );
      var result = regex.test(document.getElementById("user-mobile").value);
      if(this.mobile === ""){
        this.$bvToast.toast(this.$t("toastification.errMobile"), {
            variant: "danger",
            solid: true,
          });
      }
      if(this.firstName === ""){
        this.$bvToast.toast(this.$t("toastification.ErrFirstName"), {
            variant: "danger",
            solid: true,
          });
      }
      if(this.lastName === ""){
        this.$bvToast.toast(this.$t("toastification.ErrLastName"), {
            variant: "danger",
            solid: true,
          });
      }
      if( this.nationalCode === undefined && this.showCode){
        this.$bvToast.toast(this.$t("toastification.ErrNationalCode"), {
            variant: "danger",
            solid: true,
          });
      }
      if(this.fatherName === '' && ! this.showCode){
        this.$bvToast.toast(this.$t("toastification.ErrFatherName"), {
            variant: "danger",
            solid: true,
          });
      }
      if(!result && this.showCode){
        this.$bvToast.toast(this.$t("toastification.ErrorMobile"), {
            variant: "danger",
            solid: true,
          });
      }
      if(result && this.showCode && this.nationalCode !=null){
        let payload = {
          firstName: this.firstName,
          lastName: this.lastName,
          username: this.username,
          password: this.password,
          gender: this.gender,
          mobile: this.mobile,
          mobileCountryId: this.mobileCountryId,
          fatherName: this.fatherName,
          addresses: this.addresses,
          countryId: this.countryId,
          nationalCode: this.nationalCode,
          status: "active",
        };
      this.$store
        .dispatch("user/editUser", {
          items: payload,
          userId: this.$route.params.id,
        })
        .then((res) => {
          this.$bvToast.toast(this.$t("toastification.submissionSucceed"), {
            variant: "success",
            solid: true,
          });
          this.$router.push({ name: "managePatients" });
        })
        .catch((error) => {
          this.$bvToast.toast(this.$t("validation.nationalCode"), {
            variant: "danger",
            solid: true,
          });
        });s
      }else if(!this.showCode && this.fatherName !== ""){
        let payload = {
          firstName: this.firstName,
          lastName: this.lastName,
          username: this.username,
          password: this.password,
          gender: this.gender,
          mobile: this.mobile,
          mobileCountryId: this.mobileCountryId,
          fatherName: this.fatherName,
          addresses: this.addresses,
          countryId: this.countryId,
          status: "active",
        };
      this.$store
        .dispatch("user/editUser", {
          items: payload,
          userId: this.$route.params.id,
        })
        .then((res) => {
          this.$bvToast.toast(this.$t("toastification.submissionSucceed"), {
            variant: "success",
            solid: true,
          });
          this.$router.push({ name: "managePatients" });
        })
        .catch((error) => {
          
        });
      }
    },
  },
}
</script>
